import { useEffect } from 'react';
import { showStickyBottomBar } from '@bridebook/web/lib/ui/actions';
import { useDispatch } from '@bridebook/web/lib/utils';

/**
 * Reports a sticky bottom bar while it is on screen, so floating buttons can move above it.
 * Each call adds itself while `shown` and removes itself when that ends or the bar unmounts.
 */
export const useStickyBottomBar = (shown: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!shown) return;
    dispatch(showStickyBottomBar(true));
    return () => {
      dispatch(showStickyBottomBar(false));
    };
  }, [dispatch, shown]);
};
